import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async (params, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.getDraftProjKpi, params, options);
    if (error) return { error, status };
    return content || { id: '' };
};
